import React, { useState, useEffect } from "react";
import { Modal, List, notification, Spin } from "antd";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import http from "../../../../helpers/http";
import { DragHandle } from "../../../../components/DragHandle";
import urldata from "../../../../urldata";

const Ordering = ({ isOpen, onClose }) => {
  const [datalist, setDatalist] = useState([]);
  const [loading, setLoading] = useState(false);
  const [fetching, setFetching] = useState(false);
  const base_url = urldata + "admin/products/brands";

  useEffect(() => {
    if (isOpen) {
      fetchBrands();
    }
  }, [isOpen]);

  const fetchBrands = async () => {
    setFetching(true);
    try {
      const { data } = await http.get(`${base_url}?sortBy=asc`);
      setDatalist(data || []);
    } catch (e) {
      setDatalist([]);
    }
    setFetching(false);
  };

  const handleOrder = async (updatedData) => {
    setLoading(true);
    try {
      const payload = {
        brands: updatedData.map((item, idx) => ({
          _id: item._id,
          sort_order: idx,
        })),
      };
      const { data } = await http.put(base_url + "/sort", payload);
      if (data) {
        notification["success"]({
          message: `Product Brands Sorting Updated Successfully`,
        });
        onClose();
      }
    } catch (e) {
      notification["error"]({ message: "Failed to update sorting" });
    }
    setLoading(false);
  };

  return (
    <Modal
      title="Product Brands Ordering"
      visible={isOpen}
      onOk={() => handleOrder(datalist)}
      okText="Update"
      confirmLoading={loading}
      onCancel={onClose}
      width={500}
    >
      {fetching ? (
        <Spin style={{ width: "100%" }} />
      ) : (
        <DragDropContext
          onDragEnd={(param) => {
            const srcI = param.source.index;
            const destI = param.destination?.index;
            if (destI !== undefined) {
              let temparray = [...datalist];
              temparray.splice(destI, 0, temparray.splice(srcI, 1)[0]);
              setDatalist(temparray);
            }
          }}
        >
          <Droppable droppableId="droppable-1">
            {(provided, _) => (
              <div
                ref={provided.innerRef}
                {...provided.droppableProps}
                style={{ maxHeight: 400, overflow: "auto" }}
              >
                <List
                  bordered
                  dataSource={datalist}
                  renderItem={(item, i) => (
                    <Draggable key={item._id} draggableId={item._id} index={i}>
                      {(provided, snapshot) => (
                        <div ref={provided.innerRef}>
                          <List.Item
                            {...provided.draggableProps}
                            style={{
                              ...provided.draggableProps.style,
                              boxShadow: snapshot.isDragging
                                ? "0 0 .4rem #666"
                                : "none",
                            }}
                          >
                            <span>{item.name}</span>
                            <DragHandle {...provided.dragHandleProps} />
                          </List.Item>
                        </div>
                      )}
                    </Draggable>
                  )}
                />
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </DragDropContext>
      )}
    </Modal>
  );
};

export default Ordering;
